import { combineReducers } from "redux";
import { CURRENT_LESSON_SET, CURRENT_MODULE_SET, MODULE_LIST_SET, SET_MODULE_COMPLETE, SET_PROCESSING, USER_ADDRESS, USER_WATCHED_VIDEO } from "../constants/module";
import { data } from '../data/module';

const list = (state = data, action) => {
  if (action.type === MODULE_LIST_SET) {
    return action.data;
  }

  return state;
};

const _ = (state = {}, action) => {
  if (action.type === CURRENT_MODULE_SET) {
    return action.value;
  }

  return state;
}

const lesson = (state = {}, action) => {
  if (action.type === CURRENT_LESSON_SET) {
    return action.value;
  }

  return state;
}
const userAdd = (state = "", action) => {
  if (action.type === USER_ADDRESS) {
    return action.value;
  }

  return state;
}
const userWatchedVideo = (state = [], action) => {
  if (action.type === USER_WATCHED_VIDEO) {
    return action.value;
  }

  return state;
}
const processing = (state = true, action) => {
  if (action.type === SET_PROCESSING) {
    return action.value;
  }

  return state;
}


export default combineReducers({
  list,
  _,
  lesson,
  userAdd,
  userWatchedVideo,
  processing,
});
